<template>
  <div class="app-container">
    <div class="flex justify-between items-center mb-4">
      <el-form ref="queryForm"
               :model="queryParams"
               :inline="true"
               label-width="68px">
     

        <el-form-item label="菜谱名称"
                      prop="menuName">
          <el-input v-model="queryParams.menuName"
                    placeholder="请输入菜谱名称"
                    clearable
                    size="small" />
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     :loading="loading"
                     size="mini"
                     @click="handleQuery">查询</el-button>
          <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
      
      <el-button type="primary"
                 icon="el-icon-plus"
                 size="mini"
                 @click="handleAdd">新增菜谱</el-button>
    </div>
    
    <div class="gap"></div>
    
    <el-table v-loading="loading"
              :data="list">
      <el-table-column label="菜谱名称"
                       label-class-name="title"
                       align="center"
                       prop="menuName" />
      <el-table-column label="开始日期"
                       label-class-name="title"
                       align="center"
                       prop="startDate" />
      <el-table-column label="结束日期"
                       label-class-name="title"
                       align="center"
                       prop="endDate" />
      <!-- <el-table-column label="创建人"
                       label-class-name="title"
                       align="center"
                       prop="creator" />
      <el-table-column label="创建时间"
                       label-class-name="title"
                       align="center"
                       prop="createTime" /> -->
      <el-table-column label="周一"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周一')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="周二"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周二')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="周三"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周三')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="周四"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周四')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="周五"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周五')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="周六"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周六')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="周日"
                       label-class-name="title"
                       align="center">
        <template slot-scope="scope">
          <el-button size="mini"
                     type="primary"
                     @click="handleBrowse(scope.row, '周日')">查看详情</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       label-class-name="title"
                       class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-view"
                     @click="handleView(scope.row)">查看</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-edit"
                     @click="handleUpdate(scope.row)">修改</el-button>
          <el-button class="inspect-button"
                     size="mini"
                     type="text"
                     icon="el-icon-delete"
                     @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    
    <el-pagination
      v-show="total>0"
      :total="total"
      @current-change="getList"
      @prev-click='getList'
      @next-click="getList"
    />

    <!-- 菜谱编辑对话框 -->
    <el-dialog title="菜谱管理"
               :visible.sync="open"
               :close-on-click-modal="false"
               width="1200px"
               append-to-body>
      <el-form ref="form"
               :model="form"
               :rules="rules"
               label-width="100px"
               size="mini">
        <el-row>
          <el-col :span="12">
            <el-form-item label="菜谱名称" prop="menuName">
              <el-input v-model="form.menuName"
                        :disabled='disabled'
                        clearable
                        size="small" placeholder="请输入菜谱名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司名称" prop="companyName">
              <el-input v-model="form.companyName"
                        disabled
                        clearable
                        size="small" placeholder="请输入公司名称" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker
                v-model="form.startDate"
                :disabled='disabled'
                type="date"
                placeholder="选择开始日期"
                value-format="yyyy-MM-dd"
                style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker
                v-model="form.endDate"
                :disabled='disabled'
                type="date"
                placeholder="选择结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 一周菜谱表格 -->
        <el-divider content-position="left">一周菜谱</el-divider>
        <el-table :data="form.weeklyMenu"
                  border
                  style="width: 100%"
                  :disabled='disabled'>
          <el-table-column label="星期"
                           align="center"
                           width="100">
            <template slot-scope="scope">
              {{ scope.row.day }}
            </template>
          </el-table-column>
          <el-table-column label="早餐"
                           align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.breakfast"
                        :disabled='disabled'
                        type="textarea"
                        :rows="2"
                        placeholder="请输入早餐菜品" />
            </template>
          </el-table-column>
          <el-table-column label="午餐"
                           align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.lunch"
                        :disabled='disabled'
                        type="textarea"
                        :rows="2"
                        placeholder="请输入午餐菜品" />
            </template>
          </el-table-column>
          <el-table-column label="晚餐"
                           align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.dinner"
                        :disabled='disabled'
                        type="textarea"
                        :rows="2"
                        placeholder="请输入晚餐菜品" />
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      
      <div slot="footer"
           class="dialog-footer">
        <el-button type="primary"
                   :disabled='disabled'
                   @click="submit">确定</el-button>
        <el-button @click="open = false">关闭</el-button>
      </div>
    </el-dialog>
    
    <!-- 报名情况弹窗 -->
    <el-dialog title="报名情况" 
               :visible.sync="browseDialogVisible" 
               :close-on-click-modal="false" 
               width="800px"
               append-to-body>
      <el-table v-loading="browseLoading" 
                :data="browseList">
        <el-table-column label="姓名" align="center" prop="userInfo.name" />
          <el-table-column label="部门" align="center" prop="userInfo.department" />
        <el-table-column label="性别" align="center" prop="userInfo.gender">
          <!-- <template slot-scope="scope">
            {{ scope.row.userInfo.gender === '1' ? '男' : '女' }}
          </template> -->
        </el-table-column>
        <el-table-column label="联系电话" align="center" prop="userInfo.phone" />
        <!-- <el-table-column label="报名时间" align="center" prop="enrollTime" /> -->
        <!-- <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === '1' ? 'success' : 'warning'">
              {{ scope.row.status === '1' ? '已确认' : '待确认' }}
            </el-tag>
          </template>
        </el-table-column> -->
      </el-table>
      
      <el-pagination
        v-show="browseTotal>0"
        :total="browseTotal"
      />
      
      <div slot="footer" class="dialog-footer">
        <el-button @click="browseDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { addMenu, getMenuList, updateMenu, deleteMenu } from '../api/menu/index'
import { orderList } from '../api/menu/index'

export default {
  name: 'MenuManage',
  data () {
    return {
      pageIndex: 1,
      pageSize: 10,
      disabled: false,
      queryParams: {},
      loading: false,
      list: [],
      total: 0,
      open: false,
      userInfo: null,
      form: {
        menuName: '',
        companyName: '',
        creator: '',
        startDate: '',
        endDate: '',
        weeklyMenu: [
          { day: '周一', breakfast: '', lunch: '', dinner: '' },
          { day: '周二', breakfast: '', lunch: '', dinner: '' },
          { day: '周三', breakfast: '', lunch: '', dinner: '' },
          { day: '周四', breakfast: '', lunch: '', dinner: '' },
          { day: '周五', breakfast: '', lunch: '', dinner: '' },
          { day: '周六', breakfast: '', lunch: '', dinner: '' },
          { day: '周日', breakfast: '', lunch: '', dinner: '' }
        ]
      },
      rules: {
        menuName: [
          { required: true, message: '请输入菜谱名称', trigger: 'blur' }
        ],
        startDate: [
          { required: true, message: '请选择开始日期', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束日期', trigger: 'change' }
        ]
      },
      // 报名情况弹窗相关数据
      browseDialogVisible: false,
      browseLoading: false,
      browseList: [],
      browseTotal: 0,
      currentMenu: null,
      currentDay: ''
    }
  },
  created () {
    console.log(localStorage.getItem('userInfo'))
    // 获取当前登录用户信息
    this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
    // 初始化查询参数，设置公司名称为当前用户的公司
    this.queryParams = {
      companyCode: this.userInfo.companyCode || ''
    }
    this.handleQuery()
  },
  methods: {
    // 新增按钮
    handleAdd () {
      this.open = true
      this.disableFun(false)
      this.form = {
        menuName: '',
        companyCode: this.userInfo.companyCode || '',
        companyName: this.userInfo.companyName || '',
        creator: this.userInfo.username || '',
        startDate: '',
        endDate: '',
        weeklyMenu: [
          { day: '周一', breakfast: '', lunch: '', dinner: '' },
          { day: '周二', breakfast: '', lunch: '', dinner: '' },
          { day: '周三', breakfast: '', lunch: '', dinner: '' },
          { day: '周四', breakfast: '', lunch: '', dinner: '' },
          { day: '周五', breakfast: '', lunch: '', dinner: '' },
          { day: '周六', breakfast: '', lunch: '', dinner: '' },
          { day: '周日', breakfast: '', lunch: '', dinner: '' }
        ]
      }
    },
    
    // 确定按钮
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(!this.form.companyCode){
            return  this.$message.error('服务异常，请稍后再试')
          }
          if (!this.form.id) {
            // 新增菜谱
            addMenu(this.form).then(res => {
              if (res.code == '200') {
                this.$message.success('新增成功')
                this.open = false
                this.handleQuery()
              } else {
                this.$message.error('服务异常')
              }
            })
          } else {
            // 修改菜谱
            updateMenu(this.form).then(res => {
              if (res.code == '200') {
                this.$message.success('修改成功')
                this.open = false
                this.handleQuery()
              } else {
                this.$message.error('服务异常')
              }
            })
          }
        } else {
          return false
        }
      })
    },
    
    // 查看
    handleView (row) {
      this.open = true
      this.form = Object.assign({}, row)
      this.disableFun(true)
    },
    
    // 修改按钮
    handleUpdate (row) {
      this.open = true
      this.form = Object.assign({}, row)
      this.disableFun(false)
    },
    
    // 禁用逻辑
    disableFun (bool) {
      this.disabled = bool
    },
    
    // 查询按钮
    handleQuery () {
      let data = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...this.queryParams
      }
      this.loading = true
      getMenuList(data).then(res => {
        this.loading = false
        if (res.code == '200') {
          this.list = res.data
          this.total = res.total
        } else {
          this.$message.error('获取数据失败')
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('网络错误')
      })
    },
    
    // 删除按钮
    handleDelete (id) {
      this.$confirm('确定要删除此菜谱吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let obj = { id: id }
        deleteMenu(obj).then(res => {
          if (res.code == '200') {
            this.$message.success('删除成功')
            this.handleQuery()
          } else {
            this.$message.error('删除失败')
          }
        })
      }).catch(() => {
        // 取消删除
      })
    },
    
    // 重置查询
    resetQuery () {
      this.queryParams = {}
      this.handleQuery()
    },
    
    // 获取列表
    getList (e) {
      this.pageIndex = e
      this.handleQuery()
    },
    
    // 处理查看详情按钮点击
    handleBrowse (row, day) {
      console.log(row)
      this.browseDialogVisible = true
           let data = {
        menuId: row.id,
        companyCode: row.companyCode || '',
        day:day
        // 这里可以根据需要添加日期参数，暂时省略
      }
      this.getBrowseList(data)
    },
    
    // 获取报名列表
    getBrowseList (data) {
      this.browseLoading = true
      orderList(data).then(res => {
        this.browseLoading = false
        if (res.code == '200') {
          this.browseList = res.data.list || []
          this.browseTotal = res.data.total || 0
        } else {
          this.$message.error('获取数据失败')
        }
      }).catch(err => {
        this.browseLoading = false
        this.$message.error('网络错误')
      })
    }
  }
}
</script>

<style scoped>
.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
}

.items-center {
  align-items: center;
}

.mb-4 {
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/menuManage/index.vue